import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/AssignmentIndOutlined.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/LocalShippingOutlined.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/views/AboutTabsView.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/home/semiAbout/semiabout.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/language/TranslationsProvider.js");
